export const HIGHCHARTS_OPTIONS={
    colors: [
        '#7cb5ec',
        '#434348',
        '#90ed7d',
        '#f7a35c',
        '#8085e9',
        '#f15c80',
        '#e4d354',
        '#2b908f',
        '#f45b5b',
        '#91e8e1'
    ],
    chart: {
        style: {
            fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',
            fontSize: '16px'
        }
    },
    title: {
        style: {
            fontWeight: 'normal',
            fontSize: '18px'
        }
    },
    plotOptions: {
        area: {
            lineWidth: 2
        },
        column: {
            borderRadius: 0
        },
        pie: {
            borderRadius: 0,
            dataLabels: {
                connectorShape: 'fixedOffset'
            }
        },
        line: {
            lineWidth: 2
        },
        spline: {
            lineWidth: 2
        }
    },
    tooltip: {
        borderWidth: 1
    },
    legend: {
        itemStyle: {
            fontWeight: 'bold'
        },
        itemHiddenStyle: {
            color: '#cccccc',
            textDecoration: 'none'
        }
    },
    xAxis: {
        labels: {
            distance: 8,
            style: {
                color: '#666666',
                fontSize: '11px'
            }
        },
        lineColor: '#ccd6eb'
    },
    yAxis: {
        labels: {
            distance: 8,
            style: {
                color: '#666666',
                fontSize: '11px'
            }
        }
    },
    colorAxis: {
        labels: {
            distance: 8,
            style: {
                color: '#666666',
                fontSize: '11px'
            }
        },
        maxColor: '#003399',
        minColor: '#e6ebf5'
    },
    scrollbar: {
        barBorderRadius: 0,
        barBorderWidth: 1,
        buttonsEnabled: true,
        height: 14,
        margin: 0,
        rifleColor: '#333',
        trackBackgroundColor: '#f2f2f2',
        trackBorderRadius: 0
    }
};
